import React, { createContext, useState, useCallback, useMemo, useEffect } from 'react';
import marketingTranslations from '../../i18n/marketing-translations';

const STORAGE_KEY = 'supervisor_marketing_lang';

const getInitialLanguage = () => {
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && ['en', 'nl', 'de'].includes(stored)) {
      return stored;
    }
    // Try to detect browser language
    const browserLang = navigator.language?.split('-')[0];
    if (['en', 'nl', 'de'].includes(browserLang)) {
      return browserLang;
    }
  }
  return 'nl'; // Default to Dutch
};

export const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(getInitialLanguage);

  const setLanguage = useCallback((lang) => {
    setLanguageState(lang);
    localStorage.setItem(STORAGE_KEY, lang);
  }, []);

  const t = useCallback((key) => {
    const keys = key.split('.');
    let value = marketingTranslations[language];
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return key; // Return key if translation not found
      }
    }
    
    return value || key;
  }, [language]);

  const languages = useMemo(() => [
    { code: 'nl', name: 'Nederlands' },
    { code: 'en', name: 'English' },
    { code: 'de', name: 'Deutsch' },
  ], []);

  const value = useMemo(() => ({
    t,
    language,
    setLanguage,
    languages
  }), [t, language, setLanguage, languages]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;